const CAP5 = {
  id: 5,
  slug: "cap5-proof-of-stake",
  title: "Capítulo 5 — Proof of Stake (PoS)",
  sections: [
    {
      heading: "¿Qué es Proof of Stake (PoS)?",
      text: [
        "Proof of Stake, o **Prueba de Participación**, es un algoritmo de consenso que permite validar transacciones y crear nuevos bloques en una blockchain **sin necesidad de usar grandes cantidades de energía**, como ocurre con Proof of Work.",
        "En lugar de minar con computadoras potentes, PoS utiliza un sistema donde los participantes **bloquean criptomonedas como garantía**. A este proceso se le llama **staking**.",
        "Los participantes que bloquean sus monedas pueden convertirse en **validadores**, y la red puede elegirlos para proponer y validar nuevos bloques."
      ]
    },
    {
      heading: "¿Cómo funciona PoS?",
      text: [
        "A grandes rasgos, el funcionamiento de Proof of Stake se puede resumir así:"
      ],
      list: [
        "Los usuarios bloquean una cantidad de criptomonedas: esto se conoce como **staking**.",
        "Quienes tienen monedas en staking pueden ser elegidos como **validadores**.",
        "La selección suele ser aleatoria, pero con más probabilidad para quienes tienen mayor participación bloqueada.",
        "El validador elegido revisa las transacciones, crea un nuevo bloque y lo anuncia a la red.",
        "Si la red acepta ese bloque como válido, el validador recibe una **recompensa**."
      ]
    },
    {
      heading: "Recompensas y penalizaciones",
      text: [
        "El sistema PoS premia a los validadores honestos, pero también puede castigarlos si actúan de forma maliciosa o negligente.",
        "Si actúan correctamente, reciben recompensas en forma de nuevas monedas o comisiones de transacción.",
        "Pero si intentan manipular datos, validar transacciones falsas o incumplen las reglas, pueden perder parte de sus monedas bloqueadas. Este mecanismo se llama **slashing**.",
        "El slashing permite reforzar la **seguridad del sistema**, ya que los validadores arriesgan su propio dinero si se comportan de forma deshonesta."
      ]
    },
    {
      heading: "¿Por qué existe Proof of Stake?",
      text: [
        "Proof of Stake surgió como alternativa a Proof of Work, para resolver algunos problemas como:"
      ],
      list: [
        "El consumo energético elevado de la minería tradicional.",
        "La necesidad de hardware costoso, como GPUs o equipos ASIC.",
        "La dificultad para escalar a grandes volúmenes de transacciones.",
        "La posible centralización de poder cuando solo unos pocos pueden costear la minería."
      ]
    },
    {
      heading: "Principales ventajas de Proof of Stake",
      list: [
        "**Eficiencia energética:** no requiere resolver cálculos complejos, por lo que consume mucha menos energía.",
        "**Escalabilidad mejorada:** puede procesar más transacciones por segundo con mayor rapidez.",
        "**Seguridad económica:** los validadores tienen incentivos para ser honestos, porque su propio dinero está en riesgo.",
        "**Menor barrera de entrada:** no se necesita hardware especializado."
      ]
    },
    {
      heading: "Desventajas y riesgos de PoS",
      list: [
        "**Mayor posibilidad de centralización:** quienes poseen más criptomonedas tienen mayor probabilidad de validar y obtener más recompensas.",
        "**Dependencia del staking:** si poca gente participa, la seguridad de la red puede disminuir.",
        "**Ataques económicos o de gobernanza:** si un grupo controla gran parte del staking, puede influir en decisiones importantes."
      ]
    },
    {
      heading: "Variantes de PoS",
      text: [
        "Existen múltiples versiones de Proof of Stake, cada una adaptada a distintos objetivos tecnológicos:",
      ],
      list: [
        "**Delegated Proof of Stake (DPoS):** los usuarios votan delegados que validan en su nombre.",
        "**Hybrid PoW/PoS:** combina minería y staking.",
        "**Nominated Proof of Stake (NPoS):** los usuarios eligen validadores, pero también comparten responsabilidad."
      ]
    },
    {
      heading: "¿Cuándo es útil Proof of Stake?",
      text: [
        "PoS es especialmente adecuado para redes que buscan **seguridad, eficiencia y buena escalabilidad**, sin depender de la minería intensiva.",
        "Es apropiado en casos como:",
      ],
      list: [
        "Sistemas de pago digital.",
        "Aplicaciones descentralizadas (DApps).",
        "Sistemas de contratos inteligentes.",
        "Redes que requieren rapidez y bajo consumo energético."
      ]
    },
    {
      heading: "Resumen del capítulo",
      text: [
        "Proof of Stake es uno de los algoritmos de consenso más utilizados en la actualidad porque **equilibra seguridad, eficiencia y sostenibilidad**.",
        "Se basa en la participación económica de los validadores, quienes bloquean criptomonedas como garantía y son recompensados si actúan correctamente.",
        "Aunque es más eficiente y escalable que Proof of Work, también conlleva riesgos como la posible centralización del poder.",
        "Comprender PoS permite entender muchas redes blockchain modernas y es la base para explorar variaciones más avanzadas como DPoS, NPoS o sistemas híbridos."
      ]
    }
  ]
};

export default CAP5;
